"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHOD = exports.ContentType = exports.Header = void 0;
var Header;
(function (Header) {
    Header["ContentType"] = "Content-Type";
    Header["Accept"] = "Accept";
    Header["Authorization"] = "Authorization";
    Header["UserAgent"] = "User-Agent";
})(Header || (exports.Header = Header = {}));
var ContentType;
(function (ContentType) {
    ContentType["JSON"] = "application/json";
    ContentType["BSON"] = "application/bson";
    ContentType["HeaderStream"] = "application/vnd.journeyapps.raw+header";
    ContentType["BSONStream"] = "application/vnd.journeyapps.bson-stream+header";
})(ContentType || (exports.ContentType = ContentType = {}));
var METHOD;
(function (METHOD) {
    METHOD["POST"] = "POST";
    METHOD["PUT"] = "PUT";
    METHOD["PATCH"] = "PATCH";
    METHOD["GET"] = "GET";
    METHOD["DELETE"] = "DELETE";
})(METHOD || (exports.METHOD = METHOD = {}));
